
// // import { useCallback, useEffect, useRef, useState } from "react";
// // import { Link, useParams } from "react-router-dom";
// // import DOMPurify from "dompurify";

// // const BASE_URL = "https://www.assocham.org";

// // const serifStyle = { fontFamily: "'Libre Caslon Display', Georgia, serif" };
// // const monoStyle = { fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace" };

// // /*
// //  * SEO / indexing notes for the banner image:
// //  * 1. It stays a real <img> with a descriptive alt (no background-image / canvas trickery),
// //  *    so Google Images and crawlers can index it directly.
// //  * 2. It is above-the-fold, so it uses loading="eager" + fetchPriority="high"
// //  *    (better LCP / Core Web Vitals, which also helps ranking).
// //  * 3. The lightbox is a pure progressive-enhancement layer: the base <img> stays in the
// //  *    DOM and is never duplicated with display:none or hidden text for SEO, so indexing
// //  *    is unaffected. The modal's large image is rendered only after the user clicks.
// //  * 4. If your API can return image width/height, add them as attributes to kill CLS.
// //  */

// // function urlFor(path, folder = "assets/images") {
// //   if (!path) return `${BASE_URL}/assets/images/events-banner-main.jpg`;
// //   if (/^https?:\/\//i.test(path)) return path;
// //   if (path.startsWith("/")) return `${BASE_URL}${path}`;
// //   if (path.startsWith("assets/")) return `${BASE_URL}/${path}`;
// //   return `${BASE_URL}/${folder}/${path}`;
// // }

// // function externalUrl(path) {
// //   if (!path) return "";
// //   return /^https?:\/\//i.test(path) ? path : `${BASE_URL}/${path.replace(/^\//, "")}`;
// // }

// // /*
// //  * File URLs (brochure/flyer) must live under https://www.assocham.org/uploads/files/
// //  * e.g. https://www.assocham.org/uploads/files/Brochure_FTFC%202026%20(1).pdf
// //  * The API can return the bare filename, a partial path, OR the OLD absolute URL
// //  * (https://www.assocham.org/Brochure_FTFC%20...pdf) which 404s. We always
// //  * extract the bare filename and rebuild it under /uploads/files/ so it works.
// //  */
// // function filesUrl(path) {
// //   if (!path) return "";
// //   let decoded;
// //   try {
// //     decoded = decodeURIComponent(String(path)); // %20 -> space, etc.
// //   } catch {
// //     decoded = String(path);
// //   }
// //   const filename = decoded.split(/[\\/]/).pop(); // last path segment only
// //   if (!filename) return "";
// //   return `https://www.assocham.org/uploads/files/${encodeURI(filename)}`;
// // }

// // function CalendarIcon() {
// //   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4M16 3v4M3 10h18" /></svg>;
// // }

// // function ClockIcon() {
// //   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>;
// // }

// // function ArrowLeftIcon() {
// //   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>;
// // }

// // function ExpandIcon() {
// //   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></svg>;
// // }

// // export default function EventDetailPage() {
// //   const { slug } = useParams();
// //   const [event, setEvent] = useState(null);
// //   const [error, setError] = useState("");
// //   const [showImage, setShowImage] = useState(false);
// //   const bannerButtonRef = useRef(null);

// //   useEffect(() => {
// //     const controller = new AbortController();
// //     setEvent(null);
// //     setError("");

// //     fetch(`${BASE_URL}/api/get_event_detail.php?event=${encodeURIComponent(slug)}`, { signal: controller.signal })
// //       .then(async (response) => {
// //         const payload = await response.json();
// //         if (!response.ok || !payload.success) throw new Error(payload.error || "Event could not be loaded.");
// //         return payload.data;
// //       })
// //       .then(setEvent)
// //       .catch((err) => {
// //         if (err.name !== "AbortError") setError(err.message);
// //       });

// //     return () => controller.abort();
// //   }, [slug]);

// //   const closeLightbox = useCallback(() => {
// //     setShowImage(false);
// //     // Return focus to the banner button for keyboard/AT users
// //     requestAnimationFrame(() => bannerButtonRef.current?.focus());
// //   }, []);

// //   if (error) return <StateBox title="Event unavailable" text={error} />;
// //   if (!event) return <StateBox title="Loading event details…" text="Please wait a moment." loading />;

// //   const eventImage = urlFor(event.image);
// //   const cleanDescription = DOMPurify.sanitize(event.description || "");
// //   const hasDocuments = Boolean(event.brochureUrl || event.flyerUrl || event.forms?.length);

// //   return (
// //     <div className="min-h-screen bg-[#F6F1E6] text-[#201A16]" style={{ fontFamily: "'Public Sans', system-ui, sans-serif" }}>
// //       <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Caslon+Display&family=Public+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@500;600&display=swap');`}</style>

// //       <header className="border-b border-[#e7ddc9] bg-[#F8F3E9]">
// //         <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
// //           <Link to="/events" className="inline-flex items-center gap-2 text-sm font-semibold text-[#7A1220] transition hover:text-[#5c0d18]">
// //             <ArrowLeftIcon /> All Events
// //           </Link>

// //           <div className="mt-8 grid gap-10 lg:grid-cols-[0.85fr_1.05fr] lg:items-center">
// //             {/* Left: text content */}
// //             <div>
// //               {event.isUpcoming && (
// //                 <span style={monoStyle} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#B7862C]">
// //                   <span className="h-1.5 w-1.5 rounded-full bg-[#B7862C]" />
// //                   Upcoming Event
// //                 </span>
// //               )}

// //               <h1 style={serifStyle} className="mt-3 text-4xl leading-[1.1] text-[#201A16] sm:text-5xl">
// //                 {event.title}
// //               </h1>

// //               <div style={monoStyle} className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[#6B6058]">
// //                 {event.date && (
// //                   <span className="inline-flex items-center gap-2">
// //                     <CalendarIcon /> {event.date}
// //                   </span>
// //                 )}
// //                 {event.startTime && (
// //                   <>
// //                     <span className="hidden h-4 w-px bg-[#d9cfb8] sm:inline-block" />
// //                     <span className="inline-flex items-center gap-2">
// //                       <ClockIcon /> {event.startTime}{event.endTime && event.endTime !== event.startTime ? ` – ${event.endTime}` : ""}
// //                     </span>
// //                   </>
// //                 )}
// //               </div>

// //               <div className="mt-5 h-px w-20 bg-[#B7862C]" />

// //               <EventButtons event={event} className="mt-8" />
// //             </div>

// //             {/* Right: framed banner — full image, no crop. Click to open lightbox */}
// //             <div className="w-full">
// //               <div className="border-2 border-[#B7862C] p-1.5">
// //                 <div className="flex items-center justify-center border border-[#201A16]/15 bg-white p-2">
// //                   <button
// //                     ref={bannerButtonRef}
// //                     type="button"
// //                     onClick={() => setShowImage(true)}
// //                     aria-label={`View full-size image: ${event.title}`}
// //                     title="Click to enlarge"
// //                     className="group relative block w-full cursor-zoom-in appearance-none border-0 bg-transparent p-0 text-left"
// //                   >
// //                     <img
// //                       src={eventImage}
// //                       alt={event.title}
// //                       loading="eager"
// //                       fetchPriority="high"
// //                       className="h-auto max-h-[620px] w-full object-contain transition duration-300 group-hover:scale-[1.01]"
// //                       onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
// //                     />
// //                     {/* Persistent corner hint */}
// //                     <span className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/40 text-white opacity-70 shadow transition group-hover:bg-black/60 group-hover:opacity-100">
// //                       <ExpandIcon />
// //                     </span>
// //                     {/* Hover pill hint */}
// //                     <span className="pointer-events-none absolute inset-0 hidden items-center justify-center sm:flex">
// //                       <span className="rounded-full bg-black/50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-white opacity-0 backdrop-blur transition duration-300 group-hover:opacity-100">
// //                         View full size
// //                       </span>
// //                     </span>
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </header>

// //       <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
// //         <div className={hasDocuments ? "grid gap-8 lg:grid-cols-[minmax(0,1fr)_310px]" : "block"}>
// //           <section className="rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm sm:p-8">
// //             <p style={monoStyle} className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B7862C]">About the event</p>
// //             <div className="prose mt-4 max-w-none prose-a:text-[#7A1220]" dangerouslySetInnerHTML={{ __html: cleanDescription }} />
// //           </section>

// //           {/* Right column: Event Documents only */}
// //           {hasDocuments && (
// //             <aside className="h-fit rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm lg:sticky lg:top-5">
// //               <h2 style={serifStyle} className="text-lg text-[#201A16]">Event Documents</h2>
// //               <div className="mt-4 flex flex-col gap-3">
// //                 <DocumentButtons event={event} fullWidth />
// //                 {event.forms?.map((form) => (
// //                   <a key={form.id} href={externalUrl(form.read_more_link)} target="_blank" rel="noreferrer" className="w-full rounded-lg border border-[#7A1220]/25 bg-[#7A1220]/5 px-4 py-2.5 text-center text-sm font-bold text-[#7A1220] hover:bg-[#7A1220]/10">
// //                     Download {form.form_name}
// //                   </a>
// //                 ))}
// //               </div>
// //             </aside>
// //           )}
// //         </div>

// //         {event.panelists?.length > 0 && (
// //           <section className="mt-10">
// //             <h2 style={serifStyle} className="text-2xl text-[#201A16]">Eminent Panelists</h2>
// //             <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
// //               {event.panelists.map((person) => (
// //                 <article key={person.id} className="overflow-hidden rounded-xl border border-[#e7ddc9] bg-white shadow-sm">
// //                   <img src={urlFor(person.image, "uploads/panelists")} alt={person.name} className="h-60 w-full object-cover" />
// //                   <div className="p-4">
// //                     <h3 className="font-bold">{person.name}</h3>
// //                     {person.about && <p className="mt-2 text-sm text-[#6B6058]">{person.about}</p>}
// //                   </div>
// //                 </article>
// //               ))}
// //             </div>
// //           </section>
// //         )}

// //         {event.sponsors?.length > 0 && (
// //           <section className="mt-10 rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm sm:p-7">
// //             <h2 style={serifStyle} className="text-2xl text-[#201A16]">Sponsors</h2>
// //             <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
// //               {event.sponsors.map((sponsor) => (
// //                 <div key={sponsor.id} className="flex h-28 items-center justify-center rounded-lg border border-[#eee6d5] p-4">
// //                   <img src={urlFor(sponsor.logo, "uploads/sponsors")} alt="Sponsor" className="max-h-full max-w-full object-contain" />
// //                 </div>
// //               ))}
// //             </div>
// //           </section>
// //         )}

// //         {event.contacts?.length > 0 && (
// //           <section className="mt-10 rounded-xl bg-[#7A1220] p-6 text-white sm:p-8">
// //             <h2 style={serifStyle} className="text-2xl">For more details, contact</h2>
// //             <div className="mt-6 grid gap-5 md:grid-cols-3">
// //               {event.contacts.map((contact) => (
// //                 <div key={contact.id} className="rounded-lg border border-white/15 bg-white/10 p-4">
// //                   <p className="font-bold">{contact.name}</p>
// //                   {contact.number && <a href={`tel:${contact.number}`} className="mt-2 block text-sm text-white/80 hover:text-white">📞 {contact.number}</a>}
// //                   {contact.email && <a href={`mailto:${contact.email}`} className="mt-2 block text-sm text-white/80 hover:text-white">✉ {contact.email}</a>}
// //                 </div>
// //               ))}
// //             </div>
// //           </section>
// //         )}
// //       </main>

// //       {/* Lightbox modal */}
// //       <ImageLightbox
// //         open={showImage}
// //         onClose={closeLightbox}
// //         src={eventImage}
// //         alt={event.title}
// //         caption={event.date ? `${event.title} — ${event.date}` : event.title}
// //       />
// //     </div>
// //   );
// // }

// // /* ------------------------------ Lightbox modal ------------------------------ */

// // function ImageLightbox({ open, onClose, src, alt, caption }) {
// //   useEffect(() => {
// //     if (!open) return;
// //     const onKey = (e) => {
// //       if (e.key === "Escape") onClose();
// //     };
// //     document.addEventListener("keydown", onKey);
// //     document.body.style.overflow = "hidden"; // lock page scroll while open
// //     return () => {
// //       document.removeEventListener("keydown", onKey);
// //       document.body.style.overflow = "";
// //     };
// //   }, [open, onClose]);

// //   if (!open) return null;

// //   return (
// //     <div
// //       role="dialog"
// //       aria-modal="true"
// //       aria-label={caption ? `Enlarged image: ${caption}` : "Enlarged event image"}
// //       className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 p-4 sm:p-8"
// //       onClick={onClose}
// //     >
// //       {/* Modal panel — top bar (X bar) + centered image */}
// //       <div
// //         className="relative w-full max-w-5xl overflow-hidden rounded-xl bg-[#F8F3E9] shadow-2xl"
// //         onClick={(e) => e.stopPropagation()}
// //       >
// //         {/* X bar: title left, close button right */}
// //         <div className="flex items-center justify-between gap-4 bg-[#7A1220] px-4 py-3 sm:px-5">
// //           <p className="truncate font-semibold text-white">{caption || "Event Image"}</p>
// //           <button
// //             type="button"
// //             onClick={onClose}
// //             autoFocus
// //             aria-label="Close enlarged image"
// //             className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white/15 text-xl leading-none text-white transition hover:bg-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
// //           >
// //             ×
// //           </button>
// //         </div>

// //         {/* Image — centered in the middle of the screen */}
// //         <figure className="flex items-center justify-center bg-white p-4 sm:p-6">
// //           <img
// //             src={src}
// //             alt={alt}
// //             className="max-h-[80vh] w-auto max-w-full rounded-md object-contain"
// //             onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
// //           />
// //         </figure>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ------------------------------ Buttons ------------------------------ */

// // function EventButtons({ event, className = "", fullWidth = false }) {
// //   return (
// //     <div className={`flex flex-wrap gap-3 ${className}`}>
// //       {event.registrationUrl && (
// //         <a
// //           href={externalUrl(event.registrationUrl)}
// //           target="_blank"
// //           rel="noreferrer"
// //           className={`${fullWidth ? "w-full justify-center" : ""} inline-flex items-center rounded-md bg-[#7A1220] px-5 py-3 text-sm font-bold text-white shadow hover:bg-[#5c0d18]`}
// //         >
// //           {event.registrationLabel || "Register Now"} →
// //         </a>
// //       )}
// //       <DocumentButtons event={event} fullWidth={fullWidth} />
// //     </div>
// //   );
// // }

// // function DocumentButtons({ event, fullWidth = false }) {
// //   const normal = `${fullWidth ? "w-full justify-center" : ""} inline-flex items-center rounded-md px-5 py-3 text-sm font-bold transition`;
// //   return (
// //     <>
// //       {event.brochureUrl && (
// //         <a href={filesUrl(event.brochureUrl)} target="_blank" rel="noreferrer" className={`${normal} border border-[#7A1220]/25 bg-white text-[#7A1220] hover:bg-[#7A1220]/5`}>
// //           📄 Brochure
// //         </a>
// //       )}
// //       {event.flyerUrl && (
// //         <a href={filesUrl(event.flyerUrl)} target="_blank" rel="noreferrer" className={`${normal} border border-[#B7862C]/40 bg-white text-[#8a611f] hover:bg-[#B7862C]/10`}>
// //           🖼 Flyer
// //         </a>
// //       )}
// //     </>
// //   );
// // }

// // /* ------------------------------ States ------------------------------ */

// // function StateBox({ title, text, loading = false }) {
// //   return (
// //     <div className="flex min-h-screen items-center justify-center bg-[#F6F1E6] px-4" style={{ fontFamily: "'Public Sans', system-ui, sans-serif" }}>
// //       <div className="w-full max-w-md rounded-xl border border-[#e7ddc9] bg-white p-8 text-center shadow-sm">
// //         {loading && <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#f0e6cf] border-t-[#7A1220]" />}
// //         <h1 style={serifStyle} className="mt-4 text-xl text-[#201A16]">{title}</h1>
// //         <p className="mt-2 text-sm text-[#6B6058]">{text}</p>
// //         {!loading && (
// //           <Link to="/events" className="mt-5 inline-flex rounded-md bg-[#7A1220] px-4 py-2 text-sm font-bold text-white hover:bg-[#5c0d18]">
// //             Back to events
// //           </Link>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }




// // new code 





// import { useCallback, useEffect, useRef, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import DOMPurify from "dompurify";

// const BASE_URL = "https://www.assocham.org/assocham_backend";

// const serifStyle = { fontFamily: "'Libre Caslon Display', Georgia, serif" };
// const monoStyle = { fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace" };

// /*
//  * SEO / indexing notes for the banner image:
//  * 1. It stays a real <img> with a descriptive alt (no background-image / canvas trickery),
//  *    so Google Images and crawlers can index it directly.
//  * 2. It is above-the-fold, so it uses loading="eager" + fetchPriority="high"
//  *    (better LCP / Core Web Vitals, which also helps ranking).
//  * 3. The lightbox is a pure progressive-enhancement layer: the base <img> stays in the
//  *    DOM and is never duplicated with display:none or hidden text for SEO, so indexing
//  *    is unaffected. The modal's large image is rendered only after the user clicks.
//  * 4. If your API can return image width/height, add them as attributes to kill CLS.
//  */

// function urlFor(path, folder = "assets/images") {
//   if (!path) return `${BASE_URL}/assets/images/events-banner-main.jpg`;
//   if (/^https?:\/\//i.test(path)) return path;
//   if (path.startsWith("/")) return `${BASE_URL}${path}`;
//   if (path.startsWith("assets/")) return `${BASE_URL}/${path}`;
//   return `${BASE_URL}/${folder}/${path}`;
// }

// function externalUrl(path) {
//   if (!path) return "";
//   return /^https?:\/\//i.test(path) ? path : `${BASE_URL}/${path.replace(/^\//, "")}`;
// }

// /*
//  * File URLs (brochure/flyer) must live under https://www.assocham.org/uploads/files/
//  * e.g. https://www.assocham.org/uploads/files/Brochure_FTFC%202026%20(1).pdf
//  * The API can return the bare filename, a partial path, OR the OLD absolute URL
//  * (https://www.assocham.org/Brochure_FTFC%20...pdf) which 404s. We always
//  * extract the bare filename and rebuild it under /uploads/files/ so it works.
//  */
// function filesUrl(path) {
//   if (!path) return "";
//   let decoded;
//   try {
//     decoded = decodeURIComponent(String(path)); // %20 -> space, etc.
//   } catch {
//     decoded = String(path);
//   }
//   const filename = decoded.split(/[\\/]/).pop(); // last path segment only
//   if (!filename) return "";
//   return `https://www.assocham.org/assocham_backend/uploads/files/${encodeURI(filename)}`;
// }

// function CalendarIcon() {
//   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4M16 3v4M3 10h18" /></svg>;
// }

// function ClockIcon() {
//   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>;
// }

// function ArrowLeftIcon() {
//   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>;
// }

// function ExpandIcon() {
//   return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></svg>;
// }

// export default function EventDetailPage() {
//   const { slug } = useParams();
//   const [event, setEvent] = useState(null);
//   const [error, setError] = useState("");
//   const [showImage, setShowImage] = useState(false);
//   const bannerButtonRef = useRef(null);

//   useEffect(() => {
//     const controller = new AbortController();
//     setEvent(null);
//     setError("");

//     fetch(`${BASE_URL}/api/get_event_detail.php?event=${encodeURIComponent(slug)}`, { signal: controller.signal })
//       .then(async (response) => {
//         const payload = await response.json();
//         if (!response.ok || !payload.success) throw new Error(payload.error || "Event could not be loaded.");
//         return payload.data;
//       })
//       .then(setEvent)
//       .catch((err) => {
//         if (err.name !== "AbortError") setError(err.message);
//       });

//     return () => controller.abort();
//   }, [slug]);

//   const closeLightbox = useCallback(() => {
//     setShowImage(false);
//     // Return focus to the banner button for keyboard/AT users
//     requestAnimationFrame(() => bannerButtonRef.current?.focus());
//   }, []);

//   if (error) return <StateBox title="Event unavailable" text={error} />;
//   if (!event) return <StateBox title="Loading event details…" text="Please wait a moment." loading />;

//   const eventImage = urlFor(event.image);
//   const cleanDescription = DOMPurify.sanitize(event.description || "");
//   const hasDocuments = Boolean(event.brochureUrl || event.flyerUrl || event.forms?.length);

//   return (
//     <div className="min-h-screen bg-[#F6F1E6] text-[#201A16]" style={{ fontFamily: "'Public Sans', system-ui, sans-serif" }}>
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Caslon+Display&family=Public+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@500;600&display=swap');`}</style>

//       {/* ============================================================
//           🔥 FIX: Custom CSS for paragraph gap (12px after each <p>)
//           ============================================================ */}
//       <style>{`
//         .event-description p {
//           margin-top: 0 !important;
//           margin-bottom: 12px !important;   /* 0.75rem = 12px gap */
//         }
//         .event-description p:last-child {
//           margin-bottom: 0 !important;      /* last paragraph ke neeche extra gap nahi */
//         }
//         /* Agar content <br> use kare toh bhi gap de */
//         .event-description br {
//           display: block;
//           content: "";
//           margin: 6px 0;
//           line-height: 0;
//         }
//         /* Agar <div> ke andar text ho toh bhi */
//         .event-description div {
//           margin-bottom: 12px !important;
//         }
//         .event-description div:last-child {
//           margin-bottom: 0 !important;
//         }
//       `}</style>

//       <header className="border-b border-[#e7ddc9] bg-[#F8F3E9]">
//         <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
//           <Link to="/events" className="inline-flex items-center gap-2 text-sm font-semibold text-[#7A1220] transition hover:text-[#5c0d18]">
//             <ArrowLeftIcon /> All Events
//           </Link>

//           <div className="mt-8 grid gap-10 lg:grid-cols-[0.85fr_1.05fr] lg:items-center">
//             {/* Left: text content */}
//             <div>
//               {event.isUpcoming && (
//                 <span style={monoStyle} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#B7862C]">
//                   <span className="h-1.5 w-1.5 rounded-full bg-[#B7862C]" />
//                   Upcoming Event
//                 </span>
//               )}

//               <h1 style={serifStyle} className="mt-3 text-4xl leading-[1.1] text-[#201A16] sm:text-5xl">
//                 {event.title}
//               </h1>

//               <div style={monoStyle} className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[#6B6058]">
//                 {event.date && (
//                   <span className="inline-flex items-center gap-2">
//                     <CalendarIcon /> {event.date}
//                   </span>
//                 )}
//                 {event.startTime && (
//                   <>
//                     <span className="hidden h-4 w-px bg-[#d9cfb8] sm:inline-block" />
//                     <span className="inline-flex items-center gap-2">
//                       <ClockIcon /> {event.startTime}{event.endTime && event.endTime !== event.startTime ? ` – ${event.endTime}` : ""}
//                     </span>
//                   </>
//                 )}
//               </div>

//               <div className="mt-5 h-px w-20 bg-[#B7862C]" />

//               <EventButtons event={event} className="mt-8" />
//             </div>

//             {/* Right: framed banner — full image, no crop. Click to open lightbox */}
//             <div className="w-full">
//               <div className="border-2 border-[#B7862C] p-1.5">
//                 <div className="flex items-center justify-center border border-[#201A16]/15 bg-white p-2">
//                   <button
//                     ref={bannerButtonRef}
//                     type="button"
//                     onClick={() => setShowImage(true)}
//                     aria-label={`View full-size image: ${event.title}`}
//                     title="Click to enlarge"
//                     className="group relative block w-full cursor-zoom-in appearance-none border-0 bg-transparent p-0 text-left"
//                   >
//                     <img
//                       src={eventImage}
//                       alt={event.title}
//                       loading="eager"
//                       fetchPriority="high"
//                       className="h-auto max-h-[620px] w-full object-contain transition duration-300 group-hover:scale-[1.01]"
//                       onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
//                     />
//                     {/* Persistent corner hint */}
//                     <span className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/40 text-white opacity-70 shadow transition group-hover:bg-black/60 group-hover:opacity-100">
//                       <ExpandIcon />
//                     </span>
//                     {/* Hover pill hint */}
//                     <span className="pointer-events-none absolute inset-0 hidden items-center justify-center sm:flex">
//                       <span className="rounded-full bg-black/50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-white opacity-0 backdrop-blur transition duration-300 group-hover:opacity-100">
//                         View full size
//                       </span>
//                     </span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
//         <div className={hasDocuments ? "grid gap-8 lg:grid-cols-[minmax(0,1fr)_310px]" : "block"}>
//           <section className="rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm sm:p-8">
//             <p style={monoStyle} className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B7862C]">About the event</p>
//             {/* 
//               🔥 Class "event-description" lagayi hai taaki custom CSS target kar sake
//               Prose ki saari styling baaki rahegi, sirf margin hum force kar rahe hain
//             */}
//             <div
//               className="event-description prose mt-4 max-w-none prose-a:text-[#7A1220]"
//               dangerouslySetInnerHTML={{ __html: cleanDescription }}
//             />
//           </section>

//           {/* Right column: Event Documents only */}
//           {hasDocuments && (
//             <aside className="h-fit rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm lg:sticky lg:top-5">
//               <h2 style={serifStyle} className="text-lg text-[#201A16]">Event Documents</h2>
//               <div className="mt-4 flex flex-col gap-3">
//                 <DocumentButtons event={event} fullWidth />
//                 {event.forms?.map((form) => (
//                   <a key={form.id} href={externalUrl(form.read_more_link)} target="_blank" rel="noreferrer" className="w-full rounded-lg border border-[#7A1220]/25 bg-[#7A1220]/5 px-4 py-2.5 text-center text-sm font-bold text-[#7A1220] hover:bg-[#7A1220]/10">
//                     Download {form.form_name}
//                   </a>
//                 ))}
//               </div>
//             </aside>
//           )}
//         </div>

//         {event.panelists?.length > 0 && (
//           <section className="mt-10">
//             <h2 style={serifStyle} className="text-2xl text-[#201A16]">Eminent Panelists</h2>
//             <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
//               {event.panelists.map((person) => (
//                 <article key={person.id} className="overflow-hidden rounded-xl border border-[#e7ddc9] bg-white shadow-sm">
//                   <img src={urlFor(person.image, "uploads/panelists")} alt={person.name} className="h-60 w-full object-cover" />
//                   <div className="p-4">
//                     <h3 className="font-bold">{person.name}</h3>
//                     {person.about && <p className="mt-2 text-sm text-[#6B6058]">{person.about}</p>}
//                   </div>
//                 </article>
//               ))}
//             </div>
//           </section>
//         )}

//         {event.sponsors?.length > 0 && (
//           <section className="mt-10 rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm sm:p-7">
//             <h2 style={serifStyle} className="text-2xl text-[#201A16]">Sponsors</h2>
//             <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
//               {event.sponsors.map((sponsor) => (
//                 <div key={sponsor.id} className="flex h-28 items-center justify-center rounded-lg border border-[#eee6d5] p-4">
//                   <img src={urlFor(sponsor.logo, "uploads/sponsors")} alt="Sponsor" className="max-h-full max-w-full object-contain" />
//                 </div>
//               ))}
//             </div>
//           </section>
//         )}

//         {event.contacts?.length > 0 && (
//           <section className="mt-10 rounded-xl bg-[#7A1220] p-6 text-white sm:p-8">
//             <h2 style={serifStyle} className="text-2xl">For more details, contact</h2>
//             <div className="mt-6 grid gap-5 md:grid-cols-3">
//               {event.contacts.map((contact) => (
//                 <div key={contact.id} className="rounded-lg border border-white/15 bg-white/10 p-4">
//                   <p className="font-bold">{contact.name}</p>
//                   {contact.number && <a href={`tel:${contact.number}`} className="mt-2 block text-sm text-white/80 hover:text-white">📞 {contact.number}</a>}
//                   {contact.email && <a href={`mailto:${contact.email}`} className="mt-2 block text-sm text-white/80 hover:text-white">✉ {contact.email}</a>}
//                 </div>
//               ))}
//             </div>
//           </section>
//         )}
//       </main>

//       {/* Lightbox modal */}
//       <ImageLightbox
//         open={showImage}
//         onClose={closeLightbox}
//         src={eventImage}
//         alt={event.title}
//         caption={event.date ? `${event.title} — ${event.date}` : event.title}
//       />
//     </div>
//   );
// }

// /* ------------------------------ Lightbox modal ------------------------------ */

// function ImageLightbox({ open, onClose, src, alt, caption }) {
//   useEffect(() => {
//     if (!open) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", onKey);
//     document.body.style.overflow = "hidden"; // lock page scroll while open
//     return () => {
//       document.removeEventListener("keydown", onKey);
//       document.body.style.overflow = "";
//     };
//   }, [open, onClose]);

//   if (!open) return null;

//   return (
//     <div
//       role="dialog"
//       aria-modal="true"
//       aria-label={caption ? `Enlarged image: ${caption}` : "Enlarged event image"}
//       className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 p-4 sm:p-8"
//       onClick={onClose}
//     >
//       {/* Modal panel — top bar (X bar) + centered image */}
//       <div
//         className="relative w-full max-w-5xl overflow-hidden rounded-xl bg-[#F8F3E9] shadow-2xl"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* X bar: title left, close button right */}
//         <div className="flex items-center justify-between gap-4 bg-[#7A1220] px-4 py-3 sm:px-5">
//           <p className="truncate font-semibold text-white">{caption || "Event Image"}</p>
//           <button
//             type="button"
//             onClick={onClose}
//             autoFocus
//             aria-label="Close enlarged image"
//             className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white/15 text-xl leading-none text-white transition hover:bg-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
//           >
//             ×
//           </button>
//         </div>

//         {/* Image — centered in the middle of the screen */}
//         <figure className="flex items-center justify-center bg-white p-4 sm:p-6">
//           <img
//             src={src}
//             alt={alt}
//             className="max-h-[80vh] w-auto max-w-full rounded-md object-contain"
//             onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
//           />
//         </figure>
//       </div>
//     </div>
//   );
// }

// /* ------------------------------ Buttons ------------------------------ */

// function EventButtons({ event, className = "", fullWidth = false }) {
//   return (
//     <div className={`flex flex-wrap gap-3 ${className}`}>
//       {event.registrationUrl && (
//         <a
//           href={externalUrl(event.registrationUrl)}
//           target="_blank"
//           rel="noreferrer"
//           className={`${fullWidth ? "w-full justify-center" : ""} inline-flex items-center rounded-md bg-[#7A1220] px-5 py-3 text-sm font-bold text-white shadow hover:bg-[#5c0d18]`}
//         >
//           {event.registrationLabel || "Register Now"} →
//         </a>
//       )}
//       <DocumentButtons event={event} fullWidth={fullWidth} />
//     </div>
//   );
// }

// function DocumentButtons({ event, fullWidth = false }) {
//   const normal = `${fullWidth ? "w-full justify-center" : ""} inline-flex items-center rounded-md px-5 py-3 text-sm font-bold transition`;
//   return (
//     <>
//       {event.brochureUrl && (
//         <a href={filesUrl(event.brochureUrl)} target="_blank" rel="noreferrer" className={`${normal} border border-[#7A1220]/25 bg-white text-[#7A1220] hover:bg-[#7A1220]/5`}>
//           📄 Brochure
//         </a>
//       )}
//       {event.flyerUrl && (
//         <a href={filesUrl(event.flyerUrl)} target="_blank" rel="noreferrer" className={`${normal} border border-[#B7862C]/40 bg-white text-[#8a611f] hover:bg-[#B7862C]/10`}>
//           🖼 Flyer
//         </a>
//       )}
//     </>
//   );
// }

// /* ------------------------------ States ------------------------------ */

// function StateBox({ title, text, loading = false }) {
//   return (
//     <div className="flex min-h-screen items-center justify-center bg-[#F6F1E6] px-4" style={{ fontFamily: "'Public Sans', system-ui, sans-serif" }}>
//       <div className="w-full max-w-md rounded-xl border border-[#e7ddc9] bg-white p-8 text-center shadow-sm">
//         {loading && <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#f0e6cf] border-t-[#7A1220]" />}
//         <h1 style={serifStyle} className="mt-4 text-xl text-[#201A16]">{title}</h1>
//         <p className="mt-2 text-sm text-[#6B6058]">{text}</p>
//         {!loading && (
//           <Link to="/events" className="mt-5 inline-flex rounded-md bg-[#7A1220] px-4 py-2 text-sm font-bold text-white hover:bg-[#5c0d18]">
//             Back to events
//           </Link>
//         )}
//       </div>
//     </div>
//   );
// }



// new new code 





import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from "dompurify";

const BASE_URL = "https://www.assocham.org/assocham_backend";

const serifStyle = { fontFamily: "'Libre Caslon Display', Georgia, serif" };
const monoStyle = { fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace" };

/*
 * SEO / indexing notes for the banner image:
 * 1. It stays a real <img> with a descriptive alt (no background-image / canvas trickery),
 *    so Google Images and crawlers can index it directly.
 * 2. It is above-the-fold, so it uses loading="eager" + fetchPriority="high"
 *    (better LCP / Core Web Vitals, which also helps ranking).
 * 3. The lightbox is a pure progressive-enhancement layer: the base <img> stays in the
 *    DOM and is never duplicated with display:none or hidden text for SEO, so indexing
 *    is unaffected. The modal's large image is rendered only after the user clicks.
 * 4. If your API can return image width/height, add them as attributes to kill CLS.
 */

function urlFor(path, folder = "assets/images") {
  if (!path) return `${BASE_URL}/assets/images/events-banner-main.jpg`;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/")) return `${BASE_URL}${path}`;
  if (path.startsWith("assets/")) return `${BASE_URL}/${path}`;
  return `${BASE_URL}/${folder}/${path}`;
}

function externalUrl(path) {
  if (!path) return "";
  return /^https?:\/\//i.test(path) ? path : `${BASE_URL}/${path.replace(/^\//, "")}`;
}

/*
 * File URLs (brochure/flyer) must live under https://assocham.org/assocham_backend/uploads/files/
 * e.g. https://assocham.org/assocham_backend/uploads/files/Brochure_FTFC%202026%20(1).pdf
 * The API can return the bare filename, a partial path, OR an OLD absolute URL
 * that 404s. We always extract the bare filename and rebuild it under
 * /assocham_backend/uploads/files/ on the non-www domain so it always resolves correctly.
 */
function filesUrl(path) {
  if (!path) return "";
  let decoded;
  try {
    decoded = decodeURIComponent(String(path)); // %20 -> space, etc.
  } catch {
    decoded = String(path);
  }
  const filename = decoded.split(/[\\/]/).pop(); // last path segment only
  if (!filename) return "";
  return `https://assocham.org/assocham_backend/uploads/files/${encodeURI(filename)}`;
}

function CalendarIcon() {
  return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4M16 3v4M3 10h18" /></svg>;
}

function ClockIcon() {
  return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>;
}

function ArrowLeftIcon() {
  return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>;
}

function ExpandIcon() {
  return <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></svg>;
}

export default function EventDetailPage() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [error, setError] = useState("");
  const [showImage, setShowImage] = useState(false);
  const bannerButtonRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    setEvent(null);
    setError("");

    fetch(`${BASE_URL}/api/get_event_detail.php?event=${encodeURIComponent(slug)}`, { signal: controller.signal })
      .then(async (response) => {
        const payload = await response.json();
        if (!response.ok || !payload.success) throw new Error(payload.error || "Event could not be loaded.");
        return payload.data;
      })
      .then(setEvent)
      .catch((err) => {
        if (err.name !== "AbortError") setError(err.message);
      });

    return () => controller.abort();
  }, [slug]);

  const closeLightbox = useCallback(() => {
    setShowImage(false);
    // Return focus to the banner button for keyboard/AT users
    requestAnimationFrame(() => bannerButtonRef.current?.focus());
  }, []);

  if (error) return <StateBox title="Event unavailable" text={error} />;
  if (!event) return <StateBox title="Loading event details…" text="Please wait a moment." loading />;

  const eventImage = urlFor(event.image);
  const cleanDescription = DOMPurify.sanitize(event.description || "");
  const hasDocuments = Boolean(event.brochureUrl || event.flyerUrl || event.forms?.length);

  return (
    <div className="min-h-screen bg-[#F6F1E6] text-[#201A16]" style={{ fontFamily: "'Public Sans', system-ui, sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Caslon+Display&family=Public+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@500;600&display=swap');`}</style>

      {/* ============================================================
          🔥 FIX: Custom CSS for paragraph gap (12px after each <p>)
          ============================================================ */}
      <style>{`
        .event-description p {
          margin-top: 0 !important;
          margin-bottom: 12px !important;   /* 0.75rem = 12px gap */
        }
        .event-description p:last-child {
          margin-bottom: 0 !important;      /* last paragraph ke neeche extra gap nahi */
        }
        /* Agar content <br> use kare toh bhi gap de */
        .event-description br {
          display: block;
          content: "";
          margin: 6px 0;
          line-height: 0;
        }
        /* Agar <div> ke andar text ho toh bhi */
        .event-description div {
          margin-bottom: 12px !important;
        }
        .event-description div:last-child {
          margin-bottom: 0 !important;
        }
      `}</style>

      <header className="border-b border-[#e7ddc9] bg-[#F8F3E9]">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
          <Link to="/events" className="inline-flex items-center gap-2 text-sm font-semibold text-[#7A1220] transition hover:text-[#5c0d18]">
            <ArrowLeftIcon /> All Events
          </Link>

          <div className="mt-8 grid gap-10 lg:grid-cols-[0.85fr_1.05fr] lg:items-center">
            {/* Left: text content */}
            <div>
              {event.isUpcoming && (
                <span style={monoStyle} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#B7862C]">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#B7862C]" />
                  Upcoming Event
                </span>
              )}

              <h1 style={serifStyle} className="mt-3 text-4xl leading-[1.1] text-[#201A16] sm:text-5xl">
                {event.title}
              </h1>

              <div style={monoStyle} className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[#6B6058]">
                {event.date && (
                  <span className="inline-flex items-center gap-2">
                    <CalendarIcon /> {event.date}
                  </span>
                )}
                {event.startTime && (
                  <>
                    <span className="hidden h-4 w-px bg-[#d9cfb8] sm:inline-block" />
                    <span className="inline-flex items-center gap-2">
                      <ClockIcon /> {event.startTime}{event.endTime && event.endTime !== event.startTime ? ` – ${event.endTime}` : ""}
                    </span>
                  </>
                )}
              </div>

              <div className="mt-5 h-px w-20 bg-[#B7862C]" />

              <EventButtons event={event} className="mt-8" />
            </div>

            {/* Right: framed banner — full image, no crop. Click to open lightbox */}
            <div className="w-full">
              <div className="border-2 border-[#B7862C] p-1.5">
                <div className="flex items-center justify-center border border-[#201A16]/15 bg-white p-2">
                  <button
                    ref={bannerButtonRef}
                    type="button"
                    onClick={() => setShowImage(true)}
                    aria-label={`View full-size image: ${event.title}`}
                    title="Click to enlarge"
                    className="group relative block w-full cursor-zoom-in appearance-none border-0 bg-transparent p-0 text-left"
                  >
                    <img
                      src={eventImage}
                      alt={event.title}
                      loading="eager"
                      fetchPriority="high"
                      className="h-auto max-h-[620px] w-full object-contain transition duration-300 group-hover:scale-[1.01]"
                      onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
                    />
                    {/* Persistent corner hint */}
                    <span className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/40 text-white opacity-70 shadow transition group-hover:bg-black/60 group-hover:opacity-100">
                      <ExpandIcon />
                    </span>
                    {/* Hover pill hint */}
                    <span className="pointer-events-none absolute inset-0 hidden items-center justify-center sm:flex">
                      <span className="rounded-full bg-black/50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-white opacity-0 backdrop-blur transition duration-300 group-hover:opacity-100">
                        View full size
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
        <div className={hasDocuments ? "grid gap-8 lg:grid-cols-[minmax(0,1fr)_310px]" : "block"}>
          <section className="rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm sm:p-8">
            <p style={monoStyle} className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B7862C]">About the event</p>
            {/* 
              🔥 Class "event-description" lagayi hai taaki custom CSS target kar sake
              Prose ki saari styling baaki rahegi, sirf margin hum force kar rahe hain
            */}
            <div
              className="event-description prose mt-4 max-w-none prose-a:text-[#7A1220]"
              dangerouslySetInnerHTML={{ __html: cleanDescription }}
            />
          </section>

          {/* Right column: Event Documents only */}
          {hasDocuments && (
            <aside className="h-fit rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm lg:sticky lg:top-5">
              <h2 style={serifStyle} className="text-lg text-[#201A16]">Event Documents</h2>
              <div className="mt-4 flex flex-col gap-3">
                <DocumentButtons event={event} fullWidth />
                {event.forms?.map((form) => (
                  <a key={form.id} href={externalUrl(form.read_more_link)} target="_blank" rel="noreferrer" className="w-full rounded-lg border border-[#7A1220]/25 bg-[#7A1220]/5 px-4 py-2.5 text-center text-sm font-bold text-[#7A1220] hover:bg-[#7A1220]/10">
                    Download {form.form_name}
                  </a>
                ))}
              </div>
            </aside>
          )}
        </div>

        {event.panelists?.length > 0 && (
          <section className="mt-10">
            <h2 style={serifStyle} className="text-2xl text-[#201A16]">Eminent Panelists</h2>
            <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {event.panelists.map((person) => (
                <article key={person.id} className="overflow-hidden rounded-xl border border-[#e7ddc9] bg-white shadow-sm">
                  <img src={urlFor(person.image, "uploads/panelists")} alt={person.name} className="h-60 w-full object-cover" />
                  <div className="p-4">
                    <h3 className="font-bold">{person.name}</h3>
                    {person.about && <p className="mt-2 text-sm text-[#6B6058]">{person.about}</p>}
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}

        {event.sponsors?.length > 0 && (
          <section className="mt-10 rounded-xl border border-[#e7ddc9] bg-white p-5 shadow-sm sm:p-7">
            <h2 style={serifStyle} className="text-2xl text-[#201A16]">Sponsors</h2>
            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
              {event.sponsors.map((sponsor) => (
                <div key={sponsor.id} className="flex h-28 items-center justify-center rounded-lg border border-[#eee6d5] p-4">
                  <img src={urlFor(sponsor.logo, "uploads/sponsors")} alt="Sponsor" className="max-h-full max-w-full object-contain" />
                </div>
              ))}
            </div>
          </section>
        )}

        {event.contacts?.length > 0 && (
          <section className="mt-10 rounded-xl bg-[#7A1220] p-6 text-white sm:p-8">
            <h2 style={serifStyle} className="text-2xl">For more details, contact</h2>
            <div className="mt-6 grid gap-5 md:grid-cols-3">
              {event.contacts.map((contact) => (
                <div key={contact.id} className="rounded-lg border border-white/15 bg-white/10 p-4">
                  <p className="font-bold">{contact.name}</p>
                  {contact.number && <a href={`tel:${contact.number}`} className="mt-2 block text-sm text-white/80 hover:text-white">📞 {contact.number}</a>}
                  {contact.email && <a href={`mailto:${contact.email}`} className="mt-2 block text-sm text-white/80 hover:text-white">✉ {contact.email}</a>}
                </div>
              ))}
            </div>
          </section>
        )}
      </main>

      {/* Lightbox modal */}
      <ImageLightbox
        open={showImage}
        onClose={closeLightbox}
        src={eventImage}
        alt={event.title}
        caption={event.date ? `${event.title} — ${event.date}` : event.title}
      />
    </div>
  );
}

/* ------------------------------ Lightbox modal ------------------------------ */

function ImageLightbox({ open, onClose, src, alt, caption }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden"; // lock page scroll while open
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={caption ? `Enlarged image: ${caption}` : "Enlarged event image"}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 p-4 sm:p-8"
      onClick={onClose}
    >
      {/* Modal panel — top bar (X bar) + centered image */}
      <div
        className="relative w-full max-w-5xl overflow-hidden rounded-xl bg-[#F8F3E9] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* X bar: title left, close button right */}
        <div className="flex items-center justify-between gap-4 bg-[#7A1220] px-4 py-3 sm:px-5">
          <p className="truncate font-semibold text-white">{caption || "Event Image"}</p>
          <button
            type="button"
            onClick={onClose}
            autoFocus
            aria-label="Close enlarged image"
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white/15 text-xl leading-none text-white transition hover:bg-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            ×
          </button>
        </div>

        {/* Image — centered in the middle of the screen */}
        <figure className="flex items-center justify-center bg-white p-4 sm:p-6">
          <img
            src={src}
            alt={alt}
            className="max-h-[80vh] w-auto max-w-full rounded-md object-contain"
            onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
          />
        </figure>
      </div>
    </div>
  );
}

/* ------------------------------ Buttons ------------------------------ */

function EventButtons({ event, className = "", fullWidth = false }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {event.registrationUrl && (
        <a
          href={externalUrl(event.registrationUrl)}
          target="_blank"
          rel="noreferrer"
          className={`${fullWidth ? "w-full justify-center" : ""} inline-flex items-center rounded-md bg-[#7A1220] px-5 py-3 text-sm font-bold text-white shadow hover:bg-[#5c0d18]`}
        >
          {event.registrationLabel || "Register Now"} →
        </a>
      )}
      <DocumentButtons event={event} fullWidth={fullWidth} />
    </div>
  );
}

function DocumentButtons({ event, fullWidth = false }) {
  const normal = `${fullWidth ? "w-full justify-center" : ""} inline-flex items-center rounded-md px-5 py-3 text-sm font-bold transition`;
  return (
    <>
      {event.brochureUrl && (
        <a href={filesUrl(event.brochureUrl)} target="_blank" rel="noreferrer" className={`${normal} border border-[#7A1220]/25 bg-white text-[#7A1220] hover:bg-[#7A1220]/5`}>
          📄 Brochure
        </a>
      )}
      {event.flyerUrl && (
        <a href={filesUrl(event.flyerUrl)} target="_blank" rel="noreferrer" className={`${normal} border border-[#B7862C]/40 bg-white text-[#8a611f] hover:bg-[#B7862C]/10`}>
          🖼 Flyer
        </a>
      )}
    </>
  );
}

/* ------------------------------ States ------------------------------ */

function StateBox({ title, text, loading = false }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F6F1E6] px-4" style={{ fontFamily: "'Public Sans', system-ui, sans-serif" }}>
      <div className="w-full max-w-md rounded-xl border border-[#e7ddc9] bg-white p-8 text-center shadow-sm">
        {loading && <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#f0e6cf] border-t-[#7A1220]" />}
        <h1 style={serifStyle} className="mt-4 text-xl text-[#201A16]">{title}</h1>
        <p className="mt-2 text-sm text-[#6B6058]">{text}</p>
        {!loading && (
          <Link to="/events" className="mt-5 inline-flex rounded-md bg-[#7A1220] px-4 py-2 text-sm font-bold text-white hover:bg-[#5c0d18]">
            Back to events
          </Link>
        )}
      </div>
    </div>
  );
}